import React from 'react'
import pt from 'prop-types'
import noop from 'lodash/noop'
import memoWithName from '@/hocs/memoWithName'
import useSvgColors from '@/hooks/useSvgColors'

const HomeIcon = ({ color, onClick }) => {
  const {
    fill,
  } = useSvgColors(color)

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_187_4492)">
        <path  className="svgFill" fill={fill} d="M-0.00012207 21V10L7.49988 5L14.9999 10V21H9.99988V14H4.99988V21H-0.00012207ZM23.9999 2V21H16.9999V8.93L15.9999 8.27V6H13.9999V6.93L9.99988 4.27V2H23.9999ZM20.9999 14H18.9999V16H20.9999V14ZM20.9999 10H18.9999V12H20.9999V10ZM20.9999 6H18.9999V8H20.9999V6Z" />
      </g>
      <defs>
      <clipPath id="clip0_187_4492">
      <rect width="24" height="24" fill="white"/>
      </clipPath>
      </defs>
    </svg>
  )
}

HomeIcon.propTypes = {
  color: pt.string,
  onClick: pt.func,
}

HomeIcon.defaultProps = {
  color: '#1E2127',
  onClick: noop,
}

export default memoWithName(HomeIcon)

// <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path d="M10.6245 4.00146C9.56364 4.00146 8.54623 4.42289 7.79608 5.17304C7.04594 5.92318 6.62451 6.9406 6.62451 8.00146C6.62451 9.06233 7.04594 10.0797 7.79608 10.8299C8.54623 11.58 9.56364 12.0015 10.6245 12.0015C11.6854 12.0015 12.7028 11.58 13.4529 10.8299C14.2031 10.0797 14.6245 9.06233 14.6245 8.00146C14.6245 6.9406 14.2031 5.92318 13.4529 5.17304C12.7028 4.42289 11.6854 4.00146 10.6245 4.00146ZM17.6245 12.0015C17.4945 12.0015 17.3845 12.0915 17.3645 12.2115L17.1745 13.5315C16.8745 13.6615 16.5845 13.8215 16.3245 14.0015L15.0845 13.5015C14.9745 13.5015 14.8445 13.5015 14.7745 13.6315L13.7745 15.3615C13.7145 15.4715 13.7345 15.6015 13.8345 15.6815L14.8945 16.5015C14.8745 16.6715 14.8645 16.8315 14.8645 17.0015C14.8645 17.1715 14.8745 17.3315 14.8945 17.5015L13.8345 18.3215C13.7445 18.4015 13.7145 18.5315 13.7745 18.6415L14.7745 20.3715C14.8345 20.5015 14.9645 20.5015 15.0845 20.5015L16.3245 20.0015C16.5845 20.1815 16.8645 20.3515 17.1745 20.4715L17.3645 21.7915C17.3845 21.9115 17.4845 22.0015 17.6245 22.0015H19.6245C19.7345 22.0015 19.8445 21.9115 19.8645 21.7915L20.0545 20.4715C20.3545 20.3415 20.6245 20.1815 20.8945 20.0015L22.1245 20.5015C22.2545 20.5015 22.3845 20.5015 22.4545 20.3715L23.4545 18.6415C23.5145 18.5315 23.4845 18.4015 23.3945 18.3215L22.3245 17.5015C22.3445 17.3315 22.3645 17.1715 22.3645 17.0015C22.3645 16.8315 22.3545 16.6715 22.3245 16.5015L23.3845 15.6815C23.4745 15.6015 23.5045 15.4715 23.4445 15.3615L22.4445 13.6315C22.3845 13.5015 22.2545 13.5015 22.1245 13.5015L20.8945 14.0015C20.6245 13.8215 20.3545 13.6515 20.0445 13.5315L19.8545 12.2115C19.8445 12.0915 19.7345 12.0015 19.6245 12.0015H17.6245ZM10.6245 14.0015C6.20451 14.0015 2.62451 15.7915 2.62451 18.0015V20.0015H12.3045C11.8582 19.0643 11.6259 18.0395 11.6245 17.0015C11.6265 15.9968 11.8448 15.0043 12.2645 14.0915C11.7345 14.0315 11.1845 14.0015 10.6245 14.0015ZM18.6245 15.5015C19.4545 15.5015 20.1245 16.1715 20.1245 17.0015C20.1245 17.8315 19.4545 18.5015 18.6245 18.5015C17.7845 18.5015 17.1245 17.8315 17.1245 17.0015C17.1245 16.1715 17.7945 15.5015 18.6245 15.5015Z" fill="#30333A"/>
// </svg>


